import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { CROP_PRODUCT_OPTIONS } from '../constants/cropProducts';

export default function ChartsOverviewDemo(props) {

  const adder=(data, product)=>{
    var sorter = data.filter(bug=>bug.product.includes(product) && bug.status===props.status)
    var total=0
    for (var i in sorter){
      total+=parseFloat(sorter[i].qty)
    }
    
    return total
    
      }
  return (
    <BarChart
      series={[
        { data: CROP_PRODUCT_OPTIONS.map((product) => adder(props.sales, product)) }
      ]}
      height={290}
      xAxis={[{ data: CROP_PRODUCT_OPTIONS, scaleType: 'band' }]}
      margin={{ top: 10, bottom: 30, left: 40, right: 10 }}
    />
  );
}
